import React, {useEffect} from "react";
import ProductSummaryTable from '../../Components/Products/ProductSummaryTable'
import Grid from "@mui/material/Grid2";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const Products = () => {
    useEffect(() => {
        document.title = 'Products - CPC';
    }, []);
    return (
        <div>
            <Grid container
                  spacing={3}
                  justifyContent='space-between'
            >
                <Grid size={{ xs: 4, sm: 6 }} >
                    <Typography variant="h2">Products</Typography>
                </Grid>
                <Grid size={{ xs: 8, sm: 6 }} sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'right'}}
                >
                    <Link to="/products/new">
                        <Button variant="contained" color="primary">Create New Product</Button>
                    </Link>
                </Grid>
                <Grid size={{ xs: 12 }} >
                    <ProductSummaryTable />
                </Grid>
            </Grid>
        </div>
    )
};

export default Products;